import { Api } from 'models/services/api';
import { DeleteMenuCategoryQuery } from 'models/services/graphql';

import { MenuCategoryData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteMenuCategory($id: ID!) {
    ${DeleteMenuCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    deleteMenuCategory: MenuCategoryData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: MenuCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw 'invalid response';
    const document = api.response.data.deleteMenuCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };